export const hasValidVoucherData = ({ voucherType, activationId, discountVoucherId, returnIncentiveId, }) => {
    switch (voucherType) {
        case 'discountVoucher':
            return Boolean(discountVoucherId) && Boolean(activationId);
        case 'riVoucher':
            return Boolean(returnIncentiveId);
        default:
            return false;
    }
};
export const buildDiscountVoucherRedirectLocation = ({ url, customerUuid, discountVoucherId, activationId, }) => `${url}?customerUuid=${customerUuid}&activationId=${activationId}&discountVoucherId=${discountVoucherId}`;
export const buildRIVoucherRedirectLocation = ({ url, customerUuid, returnIncentiveId, }) => `${url}?customerUuid=${customerUuid}&returnIncentiveId=${returnIncentiveId}`;
